import { useProgress } from "@/hooks";
import styles from "./index.module.scss";
import type { TProgressProps } from "@/types";
import { TimeLabel } from "@/components";

type RangeProps = {
  currentTime: number;
} & TProgressProps;

const Range = (props: RangeProps) => {
  const {
    currentTime,
    isPlay,
    ...restProps
  } = props;

  const {
    rootEleRef,
    controlButtonEleRef,
  } = useProgress({
    isPlay,
    ...restProps
  });

  return (
    <div  
      ref={rootEleRef}
      className={styles["range"]}
    >
      <div
        ref={controlButtonEleRef}
        className={styles["control_button"]}
      >
        <div
          className={styles["inner"]}
        >
          {isPlay && (
            <TimeLabel
              value={currentTime}
              offset={4}
            ></TimeLabel>
          )}
        </div>
      </div>
    </div>
  )
}

export default Range;